import script from "./Customer.vue?vue&type=script&setup=true&lang=js"
export * from "./Customer.vue?vue&type=script&setup=true&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=7c28e922&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c28e922"]])

export default __exports__